import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { useT } from "../lang";

const PortfolioT = {
  pt: {
    label: "04 · trabalhos",
    heading: "CASES.",
    categories: ["tudo", "estratégia", "editorial"],
    meuPapel: "meu papel",
    conceito: "conceito",
    notaProjeto: "nota do projeto",
    imprensaLabel: "imprensa · repercussão",
    resultsLabel: "resultados · em números",
    matchAll: "tudo",
    caseTag: {
      destaque: "case · destaque",
      documentario: "case · documentário",
      editorial: "case · editorial",
      viagem: "case · viagem",
      social: "case · social",
    },
    caseSub: {
      estRedacao: "☺ estratégia + redação",
      producao: "☺ produção + estratégia",
      producaoRedes: "☺ produção + redes",
      redacao: "☺ redação + apresentação",
      editorialGuia: "☺ editorial + guia",
      gestaoEst: "☺ gestão + estratégia",
    },
  },
  en: {
    label: "04 · work",
    heading: "CASES.",
    categories: ["all", "strategy", "editorial"],
    meuPapel: "my role",
    conceito: "concept",
    notaProjeto: "project note",
    imprensaLabel: "press · coverage",
    resultsLabel: "results · in numbers",
    matchAll: "all",
    caseTag: {
      destaque: "case · featured",
      documentario: "case · documentary",
      editorial: "case · editorial",
      viagem: "case · travel",
      social: "case · social",
    },
    caseSub: {
      estRedacao: "☺ strategy + copy",
      producao: "☺ production + strategy",
      producaoRedes: "☺ production + social",
      redacao: "☺ copy + hosting",
      editorialGuia: "☺ editorial + guide",
      gestaoEst: "☺ management + strategy",
    },
  },
};

// Helper to pick a translated field: falls back to base field if _en not present
function pickL(data, base, lang) {
  if (lang === "en" && data[base + "En"]) return data[base + "En"];
  return data[base];
}

const toddy = {
  id: "toddy",
  title: "TODDY REAL OFICIAL",
  year: "2020",
  agency: "Mutato",
  client: "Toddy",
  role: "Content Strategist · Copywriter · Community Manager",
  category: "estratégia",
  tagline: "A TODDY ENTREGOU SUAS REDES PARA UMA VACA.",
  note: "Este projeto foi parte do rebranding da marca — um repensar completo da voz da Toddy nas redes sociais para se conectar com a Geração Z.",
  hero: "/toddy-01.png",
  chapters: [
    {
      n: "01",
      k: "o cenário",
      title: "APROXIMAR A MARCA DO PÚBLICO JOVEM.",
      body:
        "A Toddy queria se aproximar do público jovem e tornar sua comunicação mais relevante nas redes sociais. Para isso, entregou seus perfis para uma personagem: a vaca da marca.",
    },
    {
      n: "02",
      k: "o insight",
      title: "SE INFLUENCIADORES DOMINAM, A VACA TAMBÉM PODE.",
      body:
        "Se influenciadores e realities dominam as conversas da internet, a vaca da Toddy também poderia se tornar uma creator e gerar identificação com a Geração Z.",
    },
    {
      n: "03",
      k: "a estratégia",
      title: "UM REALITY DIGITAL CHAMADO REAL OFICIAL.",
      body:
        "Criar um reality digital, Real Oficial, com Manu Gavassi como apresentadora, personagens, desafios e influenciadores amplificando a conversa nas redes sociais.",
      image: "/toddy-04.png",
      imageCaption: "@vacarealoficial · Instagram + TikTok",
    },
    {
      n: "04",
      k: "a entrega",
      title: "CAMPANHA DE CONTEÚDO CONTÍNUO — 20+ INFLUENCIADORES.",
      body:
        "Uma campanha de conteúdo contínuo, com concurso, provas, bastidores, interação com a comunidade e mais de 20 influenciadores comentando e impulsionando a narrativa.",
      image: "/toddy-03.png",
      imageCaption: "lançamento + engajamento · Twitter + IG",
    },
    {
      n: "05",
      k: "o impacto",
      title: "A MARCA VIROU ENTRETENIMENTO.",
      body:
        "A campanha transformou a marca em entretenimento, gerando conversas orgânicas, participação do público e maior conexão com a audiência jovem.",
      image: "/toddy-02.png",
      imageCaption: "reação da comunidade · memes, replies e team-vaca",
    },
  ],
  metrics: [
    { k: "477K+", d: "views por post no Instagram" },
    { k: "85,2K", d: "seguidores @vacarealoficial (IG)" },
    { k: "38,1K", d: "seguidores no TikTok" },
    { k: "100,7K", d: "likes no TikTok" },
    { k: "1,6M", d: "alcance na conta parceira @vincynite" },
    { k: "271,5K", d: "views no vídeo com Manu Gavassi" },
  ],
};

const vozDelas = {
  id: "voz-delas",
  title: "A VOZ DELAS",
  year: "2019",
  agency: "BuzzFeed Vozes",
  client: "BuzzFeed Brasil",
  role: "Produção criativa e distribuição de conteúdo nas redes sociais",
  category: "estratégia",
  tagline: "A HISTÓRIA DO RAP CONTADA POR ELAS.",
  arte: "/a-voz-delas.png",
  concept:
    "Documentário do selo BuzzFeed Vozes que analisa a história do rap pela ótica feminina. Um projeto produzido por profissionais não-brancos, focado em diversidade e voz.",
  role_long: null,
  chapters: [
    {
      n: "01",
      k: "o cenário",
      title: "O RAP JÁ NÃO CABE MAIS EM UMA VOZ SÓ.",
      body:
        "Uma cena que sempre foi contada por homens — mas foi construída junto com as mulheres. O BuzzFeed Vozes queria estrear com um recorte que já era conversa dentro da cena, mas ainda não tinha virado documentário no Brasil.",
    },
    {
      n: "02",
      k: "o insight",
      title: "SÓ QUEM FAZ RAP PODE CONTAR A HISTÓRIA DO RAP.",
      body:
        "Não era sobre falar delas — era sobre ouvi-las. A minissérie precisava ser conduzida por elas mesmas, com uma equipe majoritariamente não-branca por trás das câmeras, das pautas ao corte final.",
    },
    {
      n: "03",
      k: "a estratégia",
      title: "TRÊS EPISÓDIOS COMO ESTREIA OFICIAL DO SELO BUZZFEED VOZES.",
      body:
        "A Voz Delas foi lançada como o primeiro projeto do selo — a bandeira editorial que o BuzzFeed Brasil usaria daqui pra frente pra falar de raça, gênero e cultura periférica com quem vive isso todo dia.",
    },
    {
      n: "04",
      k: "a entrega",
      title: "PRODUÇÃO DE CAMPO, EDIÇÃO E LANÇAMENTO CROSS-PLATAFORMA.",
      body:
        "Fui da produção criativa à distribuição nas redes sociais: pauta, ida a campo, roteiro, cortes para o feed e estratégia de estreia — Facebook, Instagram, YouTube e destaque no BuzzFeed Brasil.",
    },
    {
      n: "05",
      k: "o impacto",
      title: "UMA MINISSÉRIE QUE VIROU MANIFESTO — E MATÉRIA DE MERCADO.",
      body:
        "A Voz Delas repercutiu dentro e fora da bolha: pauta no Clube de Criação, viralização orgânica dos episódios e o nascimento do selo BuzzFeed Vozes como plataforma para novos projetos de diversidade.",
    },
  ],
  pillars: [
    { k: "rap", d: "história contada pela ótica feminina" },
    { k: "diversidade", d: "selo com profissionais não-brancos" },
    { k: "produção", d: "campo, roteiro, entrevistas e estratégia" },
    { k: "distribuição", d: "lançamento cross-plataforma no BuzzFeed Brasil" },
  ],
  press: {
    title: "com minissérie, buzzfeed lança selo de diversidade",
    outlet: "Clube de Criação",
    date: "06 · 09 · 2019",
    quote:
      "«O BuzzFeed Brasil lança nesta sexta-feira uma minissérie documental que faz a apresentação oficial de um selo de diversidade criado para conteúdo desenvolvido e executado por profissionais não-brancos: o BuzzFeed Vozes.»",
    print: "/buzzfeed-vozes-clube.jpg",
    href: "https://clubedecriacao.com.br/ultimas/buzzfeed-vozes/",
    label: "matéria completa no clube de criação",
  },
  reel: "https://www.facebook.com/plugins/video.php?height=560&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F546258502825256%2F&show_text=false&width=316&t=0",
  fallback:
    "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?auto=format&fit=crop&w=1200&q=80",
  externalUrl: "https://www.facebook.com/reel/546258502825256/",
  episodes: [
    {
      id: "Bm7aRU3Dijk",
      n: "01",
      title: "A Voz Delas — Episódio 1",
    },
    {
      id: "IL4KQF33DAY",
      n: "02",
      title: "A Voz Delas — Episódio 2",
    },
    {
      id: "ikkfT5gm1vE",
      n: "03",
      title: "A Voz Delas — Episódio 3",
    },
  ],
};

const buzzfeed = {
  id: "buzzfeed",
  title: "BUZZFEED EDITORIAL",
  year: "2019 · 2020",
  agency: "BuzzFeed Brasil",
  client: "BuzzFeed Brasil",
  role: "Editorial · Redação · Apresentação em vídeo",
  category: "editorial",
  tagline: "TEXTOS DE CULTURA POP, MÚSICA E COMPORTAMENTO — MAIS FRENTE-DE-CÂMERA.",
  concept:
    "Redação editorial + participação em vídeos no BuzzFeed Brasil. Textos sobre cultura pop, música e comportamento; e frente-de-câmera em séries do canal, do carnaval ao AmarElo, do Sunday Service à casa da Maga Moura.",
  role_long:
    "Escrevi matérias sobre música, cultura pop e comportamento e participei de séries do BuzzFeed no YouTube — como pauteira, entrevistadora e apresentadora eventual.",
  articles: [
    {
      title: "Estamos obcecados pela casa da Maga Moura",
      kicker: "cultura pop · casa",
      color: "bg-brick text-off",
      href: "https://web.archive.org/web/20201110115711/https://www.buzzfeed.com/br/gabrielaferraz/estamos-obececados-pela-casa-da-maga-moura",
    },
    {
      title: "Duas brasileiras foram ao Sunday Service do Kanye West e nos contam como é",
      kicker: "música · reportagem",
      color: "bg-ink text-off",
      href: "https://web.archive.org/web/20200803123449/https://www.buzzfeed.com/br/gabrielaferraz/sunday-service-kanye-west",
    },
    {
      title: "Como ajudamos o Emicida a fazer um feat com a Ivete Sangalo",
      kicker: "bastidor · música",
      color: "bg-off text-ink",
      href: "https://web.archive.org/web/20201024212741/https://www.buzzfeed.com/br/gabrielaferraz/emicida-feat-ivete-sangalo-e-vozes",
    },
  ],
  videos: [
    {
      id: "pSqxU3Fcbvg",
      title: "Mulheres e homens comparam o que têm em suas bolsas",
      series: "BuzzFeed · série",
    },
    {
      id: "mDfuPOYI7mI",
      title: "Drik Barbosa ensina 5 passinhos pro carnaval",
      series: "BuzzFeed · carnaval",
    },
    {
      id: "25OUoMoxpHU",
      title: "Emicida responde 30 perguntas em 3 minutos sobre AmarElo",
      series: "BuzzFeed · AmarElo",
    },
  ],
  authorArchive:
    "https://web.archive.org/web/2020/https://www.buzzfeed.com/br/gabrielaferraz",
};

const sangueAzul = {
  id: "sangue-azul",
  title: "SANGUE AZUL",
  year: "2019",
  agency: "BuzzFeed Vozes × Blue Note SP",
  client: "BuzzFeed Brasil",
  role: "Produção · Estratégia de distribuição · Conteúdo para redes sociais",
  category: "editorial",
  tagline: "REIS E RAINHAS PRETOS QUE VIVERAM NO BRASIL ESCRAVOCRATA.",
  arte: "/sangue-azul-hero.png",
  concept:
    "Documentário em três episódios que resgata histórias apagadas: Chico Rei, Zacimba Gaba e Manoel Congo & Marianna Crioula. Lançado na Semana da Consciência Negra, em parceria entre BuzzFeed Vozes e Blue Note SP.",
  role_long: null,
  chapters: [
    {
      n: "01",
      k: "o cenário",
      title: "A CONSCIÊNCIA NEGRA MERECE MAIS DO QUE UMA DATA.",
      body:
        "Todo novembro a mesma pauta se repete — e todo dezembro ela some. O BuzzFeed Vozes queria entrar na Semana da Consciência Negra com um projeto que continuasse relevante depois do calendário.",
    },
    {
      n: "02",
      k: "o insight",
      title: "REIS E RAINHAS PRETOS EXISTIRAM AQUI — SÓ NÃO NOS LIVROS.",
      body:
        "A história oficial apagou nomes que lideraram revoltas, compraram alforrias e comandaram quilombos no Brasil escravocrata. Chico Rei, Zacimba Gaba, Manoel Congo e Marianna Crioula não são personagens — são ancestrais.",
    },
    {
      n: "03",
      k: "a estratégia",
      title: "PARCERIA COM O BLUE NOTE E EPISÓDIOS COMO ATO DE MEMÓRIA.",
      body:
        "Uma minissérie em três episódios, produzida pelo BuzzFeed Vozes em parceria com o Blue Note SP — cada um dedicado a uma dessas figuras, com estética documental e trilha original inspirada na sonoridade do jazz clube.",
    },
    {
      n: "04",
      k: "a entrega",
      title: "PRODUÇÃO, EDIÇÃO E DISTRIBUIÇÃO EM REDES SOCIAIS.",
      body:
        "Atuei desde a produção até a estratégia de distribuição: cortes verticais pra Instagram e Facebook, textos de apoio, chamadas semanais e a coordenação de lançamento na Semana da Consciência Negra.",
    },
    {
      n: "05",
      k: "o impacto",
      title: "REPERCUSSÃO EM VEÍCULOS DE MERCADO E ELOGIO PÚBLICO DE GILBERTO GIL.",
      body:
        "A minissérie foi pauta no Clube de Criação e no Mercadizar, viralizou nas redes e recebeu um elogio público de Gilberto Gil em um Facebook Reel — 'a história humana vai além do que se conta nos livros convencionais'.",
    },
  ],
  episodes: [
    { n: "01", who: "Chico Rei", what: "escravo que comprou sua liberdade e a de outros nas minas de Ouro Preto." },
    { n: "02", who: "Zacimba Gaba", what: "princesa de Cabinda, virou escrava, fugiu, formou quilombo e liderou revoltas no Espírito Santo." },
    { n: "03", who: "Manoel Congo & Marianna Crioula", what: "lideraram uma revolta com 400 escravos em fuga em Vassouras (RJ)." },
  ],
  print: "/sangue-azul-clube.jpg",
  externalUrl: "https://clubedecriacao.com.br/ultimas/sangue-azul/",
  externalLabel: "matéria completa no clube de criação",
  press: [
    {
      kind: "print",
      outlet: "Mercadizar.com",
      date: "20 · 11 · 2019",
      title: "BuzzFeed estreia \"Sangue Azul\", documentário sobre reis e rainhas pretos",
      image: "/sangue-azul-mercadizar.jpg",
      domain: "mercadizar.com/noticias/buzzfeed-estreia-sangue-azul",
      href: "https://mercadizar.com/noticias/buzzfeed-estreia-sangue-azul-documentario-sobre-reis-e-rainhas-pretos/",
    },
    {
      kind: "reel",
      outlet: "Gilberto Gil · Facebook",
      date: "reel · público",
      title: "«a história humana vai além do que se conta nos livros convencionais…»",
      image: "/sangue-azul-fb-reel.jpg",
      domain: "facebook.com/reel/1224552811066701",
      href: "https://www.facebook.com/reel/1224552811066701/",
      stats: "242 curtidas · 14 comentários · 48 compartilhamentos",
    },
  ],
};

const bringMe = {
  id: "bring-me",
  title: "BRING ME EM PORTUGUÊS",
  year: "2019 · 2020",
  agency: "BuzzFeed Brasil",
  client: "BuzzFeed Brasil",
  role: "Social media · Estratégia de conteúdo · Redação editorial",
  category: "editorial",
  tagline: "TRAVEL CONTENT EM PORTUGUÊS — LISTAS, GUIAS E LUGARES BRASIL.",
  concept:
    "Vertical de viagem do BuzzFeed Brasil com foco em destinos, roteiros, gastronomia e experiências pelo Brasil. Desenvolvimento de conteúdos editoriais e adaptação de pautas para diferentes formatos e plataformas sociais.",
  role_long_bringme:
    "Atuação no planejamento, produção e distribuição de conteúdos para redes sociais, transformando pautas de viagem em formatos mais atrativos para a audiência — como listas, guias, vídeos e conteúdos de oportunidade.",
  articles: [
    {
      title: "Essa praia maravilhosa fica pertinho de São Paulo",
      kicker: "roteiro · litoral",
      color: "bg-brick text-off",
      href: "https://web.archive.org/web/20200530115514/https://www.buzzfeed.com/br/gabrielaferraz/praia-maravilhosa-perto-de-sao-paulo",
    },
    {
      title: "10 momentos incríveis da Lavagem do Bonfim em Salvador",
      kicker: "cultura · bahia",
      color: "bg-ink text-off",
      href: "https://web.archive.org/web/20200130032752/https://www.buzzfeed.com/br/gabrielaferraz/10-momentos-incriveis-da-lavagem-do-bonfim-em-salvador",
    },
    {
      title: "Esse parque aquático é para quem não tem medo de altura",
      kicker: "aventura · guia",
      color: "bg-off text-ink",
      href: "https://web.archive.org/web/20200809004040/https://www.buzzfeed.com/br/gabrielaferraz/este-parque-e-perfeito-pra-quem-gosta-de-aventuras-2kpuffl1v",
    },
  ],
  video: {
    id: "FUt_kaYuHUY",
    title: "Guia Bring Me: como montar seu roteiro de viagem",
    series: "BuzzFeed · Bring Me",
  },
  reel: {
    id: "1207405371813441537",
    text: "Este saborosíssimo pão assado na hora faz um tremendo sucesso com seus recheios incríveis!",
    tags: "#BringMe #MeLeva",
    image: "/bringme-tw-pao.jpg",
    video: true,
    likes: 7,
    replies: 1,
    date: "18 · 12 · 2019",
    domain: "x.com/bringmept/status/1207405371813441537",
    href: "https://x.com/bringmept/status/1207405371813441537",
    outlet: "@bringmept · Twitter",
  },
  tweets: [
    {
      id: "1199084445690683392",
      text: "ESTA É A THREAD COM ALGUNS TRUQUES PARA ECONOMIZAR ESPAÇO NA MALA!",
      emojis: "🌎 ✈️",
      tags: "#GuiaBringMe",
      kind: "thread",
      likes: 13,
      date: "25 · 11 · 2019",
      href: "https://x.com/bringmept/status/1199084445690683392",
    },
    {
      id: "1231202019748302848",
      text: "Ir pro bloco é gostoso demais, mas voltar pra casa com todos os seus pertences e com o seu corpo intacto é melhor ainda! Por isso te damos 5 dicas pra curtir um carnaval seguro.",
      image: "/bringme-tw-1.jpg",
      video: true,
      likes: 3,
      date: "22 · 02 · 2020",
      href: "https://x.com/bringmept/status/1231202019748302848",
    },
    {
      id: "1222912994348236800",
      text: "Conta aqui pra gente.",
      emojis: "✈️ 😁",
      image: "/bringme-tw-2.jpg",
      likes: 2,
      replies: 2,
      date: "30 · 01 · 2020",
      href: "https://x.com/bringmept/status/1222912994348236800",
    },
    {
      id: "1218218852607283206",
      text: "Qual é a data limite pra desfazer as malas depois de voltar de viagem?",
      emojis: "🤔",
      kind: "text",
      likes: 4,
      replies: 3,
      date: "17 · 01 · 2020",
      href: "https://x.com/bringmept/status/1218218852607283206",
    },
    {
      id: "1201969434056896514",
      text: "Mergulhe com tubarões, lute contra vilões de Star Wars ou fuja de zumbis na Pixel VR — a maior casa de realidade virtual do Brasil!",
      image: "/bringme-tw-5.jpg",
      video: true,
      likes: 4,
      date: "03 · 12 · 2019",
      href: "https://x.com/bringmept/status/1201969434056896514",
    },
  ],
};

const engov = {
  id: "engov",
  title: "ENGOV AFTER",
  year: "2022",
  agency: "Mutato",
  client: "Engov After · Hypera Pharma",
  role: "Estratégia de conteúdo · Redação · Cobertura em tempo real",
  role_long:
    "Responsável pela gestão das redes sociais da Kopenhagen e Hypera Pharma (Addera, Buscofem, Buscopan, Benegrip, BluMel, Colflex, Engov, Neosaldina, Neo Química, Vitasay e Zero-Cal). Minhas tarefas incluíam produção de conteúdo, monitoramento de canais, planejamento estratégico e tático e gestão de influenciadores. Também monitorei tendências e engajei com comunidades, criando conteúdo em tempo real alinhado à estratégia da marca.",
  category: "estratégia",
  tagline: "A CURTIÇÃO SÓ TÁ COMEÇANDO NO #BBB22.",
  hero: "/engov-hero.png",
  concept:
    "Cobertura em tempo real do #BBB22 no Twitter do @Engov_Oficial. Uma marca de farmácia se transformou em creator: memes, jogo da discórdia, reações ao vivo e virais que colocaram Engov After no topo das conversas do reality mais assistido do país.",
  hashtag: "#EngovAfterNoBBB",
  handle: "@Engov_Oficial",
  chapters: [
    {
      n: "01",
      k: "o cenário",
      title: "UMA MARCA DE FARMÁCIA DENTRO DO MAIOR REALITY DO PAÍS.",
      body:
        "Engov After patrocinava as festas do BBB22, mas queria mais do que aparecer no letreiro do palco. Precisava furar a bolha do product placement e virar parte da conversa que o reality mais assistido do Brasil gera todo dia, do jogo da discórdia ao after.",
    },
    {
      n: "02",
      k: "o insight",
      title: "SE A MARCA É SOBRE O DEPOIS, O TWITTER É O RING DELA.",
      body:
        "A curtição não acaba quando a festa termina — ela migra pro Twitter. É lá que o público reprocessa o BBB em tempo real. Engov After não precisava explicar o que faz: precisava reagir junto, com o mesmo humor e velocidade da timeline.",
    },
    {
      n: "03",
      k: "a estratégia",
      title: "TRANSFORMAR O @ENGOV_OFICIAL EM CREATOR DA CASA.",
      body:
        "Cobertura ao vivo no Twitter com meme, thread e vídeo — sempre plugada no que acontecia dentro da casa. #EngovAfterNoBBB virou hashtag oficial da marca e brigou pelos trending topics com os brothers.",
    },
    {
      n: "04",
      k: "a entrega",
      title: "TIMELINE VIVA, DO CHECKLIST DA DISCÓRDIA AO CITRUS & BERRY VIBES.",
      body:
        "Tweets em tempo real das festas, do jogo da discórdia e das dinâmicas, IGTV no feed do @engov_oficial, viral do Citrus & Berry Vibes e reação semana a semana enquanto o Brasil comentava. A marca deixou de ser patrocinador pra virar personagem.",
    },
    {
      n: "05",
      k: "o impacto",
      title: "ENGOV VIROU CONVERSA — DENTRO E FORA DA CASA.",
      body:
        "6,4K likes só no viral do Citrus & Berry Vibes, milhares de replies debatendo o que Engov After faz, matérias no GShow e no Cidade Marketing e uma marca de farmácia que passou o BBB22 inteiro no topo das menções do reality.",
    },
  ],
  metrics: [
    { k: "6,4K", d: "likes no viral Citrus & Berry Vibes" },
    { k: "2,9K", d: "likes no vídeo do 'o que faz Engov'" },
    { k: "1,8K", d: "likes no checklist da discórdia" },
    { k: "155", d: "replies no post mais compartilhado" },
  ],
  igtv: {
    href: "https://www.instagram.com/tv/Cas-HleAvp7/",
    image: "/engov-igtv-thumb.jpg",
    text: "Quem é essa garrafinha de vermelho?",
    emojis: "👀",
    tags: "#EngovAfterNoBBB #BBB22",
    date: "04 · 03 · 2022",
    likes: 108,
    comments: 11,
    handle: "@engov_oficial",
  },
  press: [
    {
      outlet: "GShow · Globo",
      title: "Começa a Festa Engov After no BBB 22",
      subtitle:
        "Brothers curtem shows de Lexa, com participação de Matheus Carrilho, e Banda Eva neste sábado, 26/02.",
      date: "26 · 02 · 2022",
      image: "/engov-press-gshow-1.jpg",
      domain: "gshow.globo.com/realities/bbb/bbb22",
      href: "https://gshow.globo.com/realities/bbb/bbb22/tempo-real/noticia/comeca-a-festa-engov-after-no-bbb-22.ghtml",
    },
    {
      outlet: "Cidade Marketing",
      title:
        "BBB22: Engov After agita o Carnaval dentro da casa mais vigiada do Brasil",
      subtitle:
        "Ao som de Mateus Carrilho, Banda Eva e Lexa, a festa de Carnaval da marca garantiu a diversão dos participantes e trouxe prêmios de até R$ 500.",
      date: "04 · 03 · 2022",
      image: "/engov-press-cidade.jpg",
      domain: "cidademarketing.com.br",
      href: "https://www.cidademarketing.com.br/marketing/2022/03/04/bbb22-engov-after-agita-o-carnaval-dentro-da-casa-mais-vigiada-do-brasil/",
    },
    {
      outlet: "GShow · Globo · Especial Publicitário",
      title:
        "Existe um Engov After para qualquer curtição — dentro e fora do BBB 22",
      subtitle:
        "É resistência que falta para o seu rolê? Veja nossas dicas de Brother e descubra a melhor solução para o seu after!",
      date: "11 · 03 · 2022",
      image: "/engov-press-gshow-2.jpg",
      domain: "gshow.globo.com/realities/bbb/bbb22",
      href: "https://gshow.globo.com/realities/bbb/bbb22/ep/engov-after/noticia/existe-um-engov-after-para-qualquer-curticao-dentro-e-fora-do-bbb-22.ghtml",
    },
  ],
  tweets: [
    {
      id: "1497821034459938817",
      text: "Engov After Citrus e Berry Vibes julgando você sem energia no rolê.",
      tags: "#EngovAfterNoBBB #BBB22",
      image: "/engov-tw-3.jpg",
      likes: 6382,
      replies: 155,
      date: "27 · 02 · 2022",
      href: "https://x.com/Engov_Oficial/status/1497821034459938817",
      featured: true,
    },
    {
      id: "1497792253502316547",
      text: "Da próxima vez que me perguntarem o que Engov After faz, eu vou mostrar esse vídeo.",
      emojis: "🤣",
      tags: "#EngovAfterNoBBB",
      image: "/engov-tw-5.jpg",
      video: true,
      likes: 2891,
      replies: 57,
      date: "27 · 02 · 2022",
      href: "https://x.com/Engov_Oficial/status/1497792253502316547",
    },
    {
      id: "1501005769000509444",
      text: "Checklist do Jogo da Discórdia: Tampar umbigo 🌪 · Comer um pãozinho 🍞 · Enxugar lágrimas 🧬 · Tomar Engov After 🥰",
      tags: "#EngovAfterNoBBB #BBB22",
      kind: "text",
      likes: 1847,
      replies: 24,
      date: "08 · 03 · 2022",
      href: "https://x.com/Engov_Oficial/status/1501005769000509444",
    },
    {
      id: "1509362128339230720",
      text: "A linnder chegou de vermelho cheia de energia igualzinha ao Red Hits! Ou seria Red Linnts?",
      emojis: "😅 💃",
      tags: "#EngovAfterNoBBB #BBB22",
      image: "/engov-tw-1.jpg",
      video: true,
      likes: 513,
      replies: 34,
      date: "31 · 03 · 2022",
      href: "https://x.com/Engov_Oficial/status/1509362128339230720",
    },
    {
      id: "1497809447955181569",
      text: "Brothers reenergizados! A curtição só tá começando no #BBB22. Quem aí entrou pro Bonde da Curtição?",
      emojis: "😎",
      tags: "#EngovAfterNoBBB",
      image: "/engov-bonde.png",
      video: true,
      likes: 28,
      replies: 2,
      date: "27 · 02 · 2022",
      href: "https://x.com/Engov_Oficial/status/1497809447955181569",
    },
  ],
};

const tasty = {
  id: "tasty",
  title: "TASTY DEMAIS",
  year: "2019 · 2020",
  agency: "BuzzFeed Brasil",
  client: "Tasty Demais",
  role: "Gestão de redes sociais · Estratégia · Planejamento editorial",
  category: "estratégia",
  tagline: "A COMIDA VIRA CONVERSA — E A CONVERSA VIRA COMIDA.",
  concept:
    "Redes sociais da marca onde era responsável pela gestão, estratégia e todo o planejamento — do tom de voz às respostas em tempo real, dos memes de timeline aos vídeos de canal.",
  channels: [
    { name: "Instagram", handle: "@tastydemais", href: "https://www.instagram.com/tastydemais/" },
    { name: "Facebook", handle: "Tasty Demais", href: "https://www.facebook.com/tastydemais" },
    { name: "Twitter", handle: "@tastydemais", href: "https://x.com/tastydemais" },
    { name: "YouTube", handle: "Tasty Demais", href: "https://www.youtube.com/@tastydemais" },
  ],
  tweets: [
    {
      id: "1228031183864442880",
      text:
        "Você é do time que coloca o molho por cima do macarrão ou do que mistura tudo na panela?",
      image: "/tasty-tw-macarrao.jpg",
      video: true,
      likes: 1928,
      replies: 400,
      date: "13 · 02 · 2020",
      href: "https://x.com/tastydemais/status/1228031183864442880",
      featured: true,
      badge: "primeira vez no @MomentsBrasil",
      badgeHref: "https://twitter.com/i/events/1228265241743544320",
    },
    {
      id: "1224455537535807490",
      text:
        "terminou o relacionamento?\nfaz um bolo\n\ntá ficando c/ alguém e se decepcionou?\nfaz um bolo\n\nquer se declarar pra danada/o?\nfaz um bolo\n\ncrise no relacionamento?\nfaz um bolo\n\nchifre?\nfaz um bolo",
      kind: "text",
      likes: 1105,
      replies: 33,
      date: "03 · 02 · 2020",
      href: "https://x.com/tastydemais/status/1224455537535807490",
    },
    {
      id: "1225199926516150272",
      text: "mas um dia e eu jantando pipoca…",
      image: "/tasty-tw-pipoca.jpg",
      video: true,
      likes: 63,
      replies: 1,
      date: "05 · 02 · 2020",
      href: "https://x.com/tastydemais/status/1225199926516150272",
    },
  ],
  videos: [
    {
      title: "Desafio do Pão de Queijo",
      series: "Tasty Demais · Desafio",
      href: "https://www.youtube.com/@tastydemais",
      placeholder: true,
    },
    {
      title: "#TastyTesta: pessoas provam gelatos da Bacio di Latte e tentam adivinhar o sabor",
      series: "Tasty Demais · #TastyTesta",
      href: "https://www.youtube.com/@tastydemais",
      placeholder: true,
    },
    {
      title: "#TastyTesta: pessoas provam comidas veganas sem saber",
      series: "Tasty Demais · #TastyTesta",
      href: "https://www.youtube.com/@tastydemais",
      placeholder: true,
    },
    {
      title: "#TastyTesta: pessoas provam cachorros-quentes do Brasil",
      series: "Tasty Demais · #TastyTesta",
      href: "https://www.youtube.com/@tastydemais",
      placeholder: true,
    },
  ],
  metrics: [
    { k: "1,9K", d: "likes no viral do macarrão" },
    { k: "400", d: "respostas debatendo molho por cima" },
    { k: "1,1K", d: "likes na thread do bolo" },
    { k: "1x", d: "@MomentsBrasil · promoção editorial" },
  ],
};

const cases = [toddy, engov, buzzfeed, vozDelas, sangueAzul, bringMe, tasty];

export default function Portfolio() {
  const pt = useT(PortfolioT);
  const [active, setActive] = useState(pt.matchAll);
  const visible = active === pt.matchAll ? cases : cases.filter((c) => (
    (active === "estratégia" || active === "strategy") ? c.category === "estratégia"
    : (active === "editorial") ? c.category === "editorial"
    : true
  ));

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="relative py-24 md:py-32"
    >
      <div className="container-wide">
        <div className="flex items-center gap-3 mb-10">
          <span className="label">{pt.label}</span>
          <span className="text-2xl">☺</span>
        </div>

        <div className="grid grid-cols-12 gap-6 items-end mb-12">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-7 font-display uppercase text-[13vw] md:text-[7vw] leading-[0.9]"
          >
            <span className="text-brick">{pt.heading}</span>
          </motion.h2>

          <div
            className="col-span-12 md:col-span-5 flex flex-wrap gap-2 md:justify-end"
            data-testid="portfolio-filters"
          >
            {pt.categories.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                data-testid={`filter-${c}`}
                className={`filter ${active === c ? "active" : ""}`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-24 md:space-y-32">
          <AnimatePresence mode="popLayout">
            {visible.map((c) => {
              if (c.id === "toddy") return <ToddyCase key={c.id} data={c} />;
              if (c.id === "buzzfeed") return <BuzzFeedCase key={c.id} data={c} />;
              if (c.id === "voz-delas") {
                const hasSangue = visible.some((x) => x.id === "sangue-azul");
                if (!hasSangue) return <VozDelasCase key={c.id} data={c} />;
                return (
                  <BuzzFeedVozesWrapper key="buzzfeed-vozes" voz={c} sangue={visible.find((x) => x.id === "sangue-azul")} />
                );
              }
              if (c.id === "sangue-azul") {
                const hasVoz = visible.some((x) => x.id === "voz-delas");
                if (!hasVoz) return <SangueAzulCase key={c.id} data={c} />;
                return null; // rendered inside wrapper
              }
              if (c.id === "bring-me") return <BringMeCase key={c.id} data={c} />;
              if (c.id === "engov") return <EngovCase key={c.id} data={c} />;
              if (c.id === "tasty") return <TastyCase key={c.id} data={c} />;
              return null;
            })}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}

/* ─── TODDY ─── */
function ToddyCase({ data }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="border border-[color:var(--ink)] bg-off"
      data-testid="project-toddy"
    >
      {/* Header bar */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-6 md:px-10 py-4 border-b border-[color:var(--ink)] bg-ink text-off">
        <div className="flex items-center gap-4">
          <span className="label !text-off">case · destaque</span>
          <span className="label !text-off/70">☺ estratégia + redação</span>
        </div>
        <span className="font-narrow text-sm">
          {data.agency} · {data.year}
        </span>
      </div>

      {/* Hero — big Real Oficial card */}
      <div className="grid grid-cols-12 gap-0 border-b border-ink">
        <div className="col-span-12 md:col-span-6 md:border-r md:border-ink relative overflow-hidden bg-[#F5B617]">
          <img
            src={data.hero}
            alt="Concurso Real Oficial — Toddy feat Manu Gavassi"
            className="w-full h-auto block"
            loading="lazy"
            data-testid="toddy-hero-image"
          />
        </div>
        <div className="col-span-12 md:col-span-6 p-8 md:p-12 flex flex-col justify-between gap-8">
          <div>
            <div className="label mb-4">{data.client} · {data.year}</div>
            <h3 className="font-display uppercase text-[9vw] md:text-[4.8vw] leading-[0.88]">
              TODDY <span className="text-brick">REAL</span>
              <br />
              OFICIAL.
            </h3>
            <p className="mt-6 font-display uppercase text-base md:text-xl leading-[1.1] max-w-[520px]">
              {data.tagline}
            </p>
          </div>
          <div>
            <div className="label mb-2">meu papel</div>
            <div className="font-display uppercase text-base md:text-lg">
              {data.role}
            </div>
          </div>
        </div>
      </div>

      {/* Rebranding note */}
      {data.note && (
        <div
          className="border-b border-ink px-6 md:px-10 py-5 md:py-6 bg-brick text-off flex flex-col md:flex-row md:items-baseline gap-2 md:gap-6"
          data-testid="toddy-rebranding-note"
        >
          <span className="label !text-off/85 shrink-0">nota do projeto</span>
          <p className="font-display uppercase text-sm md:text-lg leading-[1.2]">
            {data.note}
          </p>
        </div>
      )}

      {/* Chapters — narrative timeline */}
      <div data-testid="toddy-chapters">
        {data.chapters.map((ch, i) => {
          const isTextOnly = !ch.image;
          const isEven = i % 2 === 0;
          const bg = i % 2 === 0 ? "bg-off" : "bg-paper";

          return (
            <div
              key={ch.n}
              className={`border-t border-ink ${bg}`}
              data-testid={`toddy-chapter-${ch.n}`}
            >
              {isTextOnly ? (
                /* Text-only chapter (01 · cenário, 02 · insight) */
                <div className="px-6 md:px-10 py-10 md:py-14 grid grid-cols-12 gap-6 md:gap-10">
                  <div className="col-span-12 md:col-span-3 flex md:flex-col items-baseline md:items-start gap-3 md:gap-4">
                    <div className="font-display text-4xl md:text-6xl text-brick leading-none">
                      {ch.n}
                    </div>
                    <div className="label">{ch.k}</div>
                  </div>
                  <div className="col-span-12 md:col-span-9">
                    <h4 className="font-display uppercase text-xl md:text-3xl leading-[1.05] mb-4">
                      {ch.title}
                    </h4>
                    <p className="font-body text-sm md:text-base leading-relaxed max-w-[720px] text-[color:var(--ink)]/85">
                      {ch.body}
                    </p>
                  </div>
                </div>
              ) : (
                /* Chapter with image */
                <div className="grid grid-cols-12 gap-0">
                  <div
                    className={`col-span-12 md:col-span-5 p-6 md:p-10 md:border-ink ${
                      isEven ? "md:border-r md:order-first" : "md:border-l md:order-last"
                    }`}
                  >
                    <div className="flex md:flex-col items-baseline md:items-start gap-3 md:gap-4 mb-5">
                      <div className="font-display text-4xl md:text-6xl text-brick leading-none">
                        {ch.n}
                      </div>
                      <div className="label">{ch.k}</div>
                    </div>
                    <h4 className="font-display uppercase text-xl md:text-2xl leading-[1.05] mb-4">
                      {ch.title}
                    </h4>
                    <p className="font-body text-sm md:text-base leading-relaxed text-[color:var(--ink)]/85">
                      {ch.body}
                    </p>
                  </div>
                  <div
                    className={`col-span-12 md:col-span-7 relative bg-ink overflow-hidden flex items-center justify-center p-4 md:p-8`}
                  >
                    <img
                      src={ch.image}
                      alt={ch.imageCaption}
                      loading="lazy"
                      className="max-w-full max-h-[520px] w-auto h-auto object-contain block"
                      data-testid={`toddy-chapter-image-${ch.n}`}
                    />
                    <div className="absolute bottom-3 left-3 flex items-center gap-2 font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off bg-ink/70 px-2 py-1">
                      <span className="text-brick">◉</span>
                      <span>{ch.imageCaption}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Results */}
      <div className="border-t border-ink bg-brick text-off px-6 md:px-10 py-8 md:py-10">
        <div className="label !text-off/85 mb-6">
          resultados · em números
        </div>
        <div className="grid grid-cols-2 md:grid-cols-6 gap-6">
          {data.metrics.map((m, j) => (
            <div key={j}>
              <div className="font-display text-3xl md:text-5xl leading-none">
                {m.k}
              </div>
              <div className="mt-2 font-narrow text-xs md:text-sm text-off/85 leading-tight">
                {m.d}
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.article>
  );
}

/* ─── A VOZ DELAS ─── */
function VozDelasCase({ data }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="border border-[color:var(--ink)] bg-paper"
      data-testid="project-voz-delas"
    >
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-6 md:px-10 py-4 border-b border-[color:var(--ink)] bg-paper">
        <div className="flex items-center gap-4">
          <span className="label">case · documentário</span>
          <span className="label text-brick">☺ produção + estratégia</span>
        </div>
        <span className="font-narrow text-sm">
          {data.agency} · {data.year}
        </span>
      </div>

      {/* Big tagline + arte */}
      <div className="border-b border-ink bg-off">
        <div className="grid grid-cols-12 gap-0">
          <div className="col-span-12 md:col-span-6 md:border-r md:border-ink px-6 md:px-10 py-10 md:py-14 flex flex-col justify-center">
            <div className="label mb-4">buzzfeed vozes apresenta</div>
            <h3 className="font-display uppercase text-[12vw] md:text-[7vw] leading-[0.85] mb-6">
              A <span className="text-brick">VOZ</span>
              <br />
              DELAS.
            </h3>
            <p className="font-display uppercase text-xl md:text-2xl leading-[1.1] max-w-md">
              {data.tagline}
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 relative bg-ink overflow-hidden">
            <img
              src={data.arte}
              alt="A Voz Delas — arte oficial com Sharylaine, Negra Li, Tasha & Tracie"
              className="w-full h-full object-cover block"
              loading="lazy"
              data-testid="voz-delas-arte"
            />
            <div className="absolute bottom-3 left-3 flex items-center gap-2 font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off bg-ink/70 px-2 py-1">
              <span className="text-brick">◉</span>
              <span>arte oficial · buzzfeed vozes</span>
            </div>
          </div>
        </div>
      </div>

      {/* Chapters — narrative timeline */}
      {data.chapters && (
        <div data-testid="voz-delas-chapters">
          {data.chapters.map((ch, i) => {
            const bg = i % 2 === 0 ? "bg-off" : "bg-paper";
            return (
              <div
                key={ch.n}
                className={`border-b border-ink ${bg}`}
                data-testid={`voz-delas-chapter-${ch.n}`}
              >
                <div className="px-6 md:px-10 py-8 md:py-12 grid grid-cols-12 gap-6 md:gap-10">
                  <div className="col-span-12 md:col-span-3 flex md:flex-col items-baseline md:items-start gap-3 md:gap-4">
                    <div className="font-display text-4xl md:text-6xl text-brick leading-none">
                      {ch.n}
                    </div>
                    <div className="label">{ch.k}</div>
                  </div>
                  <div className="col-span-12 md:col-span-9">
                    <h4 className="font-display uppercase text-xl md:text-3xl leading-[1.05] mb-4">
                      {ch.title}
                    </h4>
                    <p className="font-body text-sm md:text-base leading-relaxed max-w-[720px] text-[color:var(--ink)]/85">
                      {ch.body}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Episodes + content split */}
      <div className="grid grid-cols-12 gap-0">
        {/* Episodes stack */}
        <div
          className="col-span-12 md:col-span-5 md:border-r md:border-ink bg-ink p-4 md:p-6 space-y-3"
          data-testid="voz-delas-episodes"
        >
          <div className="label !text-off/70 mb-2 px-2">
            três episódios no youtube
          </div>
          {data.episodes.map((ep, i) => (
            <a
              key={ep.id}
              href={`https://www.youtube.com/watch?v=${ep.id}`}
              target="_blank"
              rel="noreferrer"
              data-testid={`voz-delas-ep-${i + 1}`}
              className="group block border border-off/20 overflow-hidden bg-black hover:border-brick transition-colors"
            >
              <div className="grid grid-cols-12 gap-0">
                <div className="col-span-5 relative aspect-video">
                  <img
                    src={`https://img.youtube.com/vi/${ep.id}/hqdefault.jpg`}
                    alt={ep.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-ink/30 group-hover:bg-ink/10 transition-colors flex items-center justify-center">
                    <span className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-brick flex items-center justify-center border border-off/20 group-hover:scale-110 transition-transform">
                      <span className="text-off text-sm md:text-base leading-none translate-x-[1px]">
                        ▶
                      </span>
                    </span>
                  </div>
                </div>
                <div className="col-span-7 p-3 md:p-4 flex flex-col justify-center">
                  <div className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick mb-1">
                    episódio {ep.n}
                  </div>
                  <div className="font-display uppercase text-off text-sm md:text-base leading-tight">
                    {ep.title}
                  </div>
                  <div className="mt-2 font-narrow text-[10px] uppercase tracking-widest text-off/60 group-hover:text-off transition-colors">
                    assistir no youtube ↗
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Content */}
        <div className="col-span-12 md:col-span-7 p-6 md:p-10">
          <div className="label mb-3">conceito</div>
          <p className="font-body text-base md:text-lg leading-relaxed mb-8">
            {data.concept}
          </p>

          <div className="label mb-3">meu papel</div>
          <div className="font-display uppercase text-lg md:text-xl mb-4">
            {data.role}
          </div>
          {data.role_long && (
            <p className="font-body text-base md:text-lg leading-relaxed mb-10 border-l-2 border-brick pl-4">
              {data.role_long}
            </p>
          )}

          <div className="grid grid-cols-2 gap-4">
            {data.pillars.map((p, i) => (
              <div
                key={p.k}
                className="border border-[color:var(--ink)]/30 p-4 bg-off/50"
              >
                <div className="font-narrow text-xs text-brick uppercase tracking-widest mb-1">
                  0{i + 1}
                </div>
                <div className="font-display uppercase text-xl md:text-2xl leading-none mb-2">
                  {p.k}
                </div>
                <div className="font-body text-sm text-[color:var(--ink)]/80">
                  {p.d}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Press · Clube de Criação — compact */}
      <div
        className="border-t border-ink bg-paper px-6 md:px-10 py-8 md:py-10"
        data-testid="voz-delas-press"
      >
        <div className="flex items-baseline justify-between mb-4 md:mb-6">
          <div className="label">imprensa · o nascimento do vozes</div>
          <span className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            {data.press.outlet} · {data.press.date}
          </span>
        </div>
        <a
          href={data.press.href}
          target="_blank"
          rel="noreferrer"
          data-testid="voz-delas-press-cta"
          className="group grid grid-cols-12 gap-4 md:gap-6 items-center border border-[color:var(--ink)] bg-off p-3 md:p-4 hover:bg-brick hover:text-off transition-colors"
        >
          <div className="col-span-3 md:col-span-2 relative overflow-hidden border border-[color:var(--ink)]/40 aspect-[4/3] bg-white">
            <img
              src={data.press.print}
              alt="Matéria sobre o nascimento do BuzzFeed Vozes no Clube de Criação"
              className="absolute inset-0 w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="col-span-9 md:col-span-9 flex flex-col gap-1 md:gap-2">
            <div className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick group-hover:text-off/85 transition-colors">
              ✷ {data.press.outlet} · {data.press.date}
            </div>
            <div className="font-display uppercase text-sm md:text-lg leading-tight">
              {data.press.title}
            </div>
            <div className="hidden md:block font-body text-xs leading-relaxed text-[color:var(--ink)]/70 group-hover:text-off/80 line-clamp-2">
              {data.press.quote}
            </div>
          </div>
          <div className="col-span-12 md:col-span-1 text-right font-narrow text-lg md:text-xl group-hover:translate-x-1 transition-transform">
            ↗
          </div>
        </a>
      </div>
    </motion.article>
  );
}

/* ─── SANGUE AZUL ─── */
function SangueAzulCase({ data }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="border border-[color:var(--ink)] bg-off"
      data-testid="project-sangue-azul"
    >
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-6 md:px-10 py-4 border-b border-[color:var(--ink)] bg-brick text-off">
        <div className="flex items-center gap-4">
          <span className="label !text-off">case · documentário</span>
          <span className="label !text-off/80">☺ produção + redes</span>
        </div>
        <span className="font-narrow text-sm">
          {data.agency} · {data.year}
        </span>
      </div>

      {/* Big title + arte */}
      <div className="border-b border-ink bg-off">
        <div className="grid grid-cols-12 gap-0">
          <div className="col-span-12 md:col-span-6 md:border-r md:border-ink px-6 md:px-10 py-10 md:py-14 flex flex-col justify-center">
            <div className="label mb-4">buzzfeed vozes × blue note sp</div>
            <h3 className="font-display uppercase text-[12vw] md:text-[7vw] leading-[0.85] mb-6">
              SANGUE
              <br />
              <span className="text-brick">AZUL.</span>
            </h3>
            <p className="font-display uppercase text-xl md:text-2xl leading-[1.1] max-w-md">
              {data.tagline}
            </p>
          </div>
          <div className="col-span-12 md:col-span-6 relative bg-[#0A2452] overflow-hidden">
            <img
              src={data.arte}
              alt="Sangue Azul — arte oficial BuzzFeed Vozes"
              className="w-full h-full object-cover block"
              loading="lazy"
              data-testid="sangue-azul-arte"
            />
            <div className="absolute bottom-3 left-3 flex items-center gap-2 font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off bg-ink/70 px-2 py-1">
              <span className="text-brick">◉</span>
              <span>arte oficial · buzzfeed vozes</span>
            </div>
          </div>
        </div>
      </div>

      {/* Chapters — narrative timeline */}
      {data.chapters && (
        <div data-testid="sangue-azul-chapters">
          {data.chapters.map((ch, i) => {
            const bg = i % 2 === 0 ? "bg-off" : "bg-paper";
            return (
              <div
                key={ch.n}
                className={`border-b border-ink ${bg}`}
                data-testid={`sangue-azul-chapter-${ch.n}`}
              >
                <div className="px-6 md:px-10 py-8 md:py-12 grid grid-cols-12 gap-6 md:gap-10">
                  <div className="col-span-12 md:col-span-3 flex md:flex-col items-baseline md:items-start gap-3 md:gap-4">
                    <div className="font-display text-4xl md:text-6xl text-brick leading-none">
                      {ch.n}
                    </div>
                    <div className="label">{ch.k}</div>
                  </div>
                  <div className="col-span-12 md:col-span-9">
                    <h4 className="font-display uppercase text-xl md:text-3xl leading-[1.05] mb-4">
                      {ch.title}
                    </h4>
                    <p className="font-body text-sm md:text-base leading-relaxed max-w-[720px] text-[color:var(--ink)]/85">
                      {ch.body}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Meu papel + compact press */}
      <div className="grid grid-cols-12 gap-0 border-b border-ink bg-paper">
        <div className="col-span-12 md:col-span-6 md:border-r md:border-ink p-6 md:p-10">
          <div className="label mb-3">meu papel</div>
          <div className="font-display uppercase text-base md:text-lg mb-4">
            {data.role}
          </div>
          {data.role_long && (
            <p className="font-body text-sm md:text-base leading-relaxed border-l-2 border-brick pl-4 text-[color:var(--ink)]/85">
              {data.role_long}
            </p>
          )}
        </div>
        <div className="col-span-12 md:col-span-6 p-6 md:p-10">
          <div className="label mb-3">imprensa · matéria completa</div>
          <a
            href={data.externalUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="sangue-azul-cta"
            className="group grid grid-cols-12 gap-3 md:gap-4 items-center border border-[color:var(--ink)] bg-off p-3 hover:bg-brick hover:text-off transition-colors"
          >
            <div className="col-span-3 relative overflow-hidden border border-[color:var(--ink)]/40 aspect-[4/3] bg-white">
              <img
                src={data.print}
                alt="Matéria sobre Sangue Azul no Clube de Criação"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="col-span-8 flex flex-col gap-1">
              <div className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick group-hover:text-off/85 transition-colors">
                ✷ clube de criação
              </div>
              <div className="font-display uppercase text-sm md:text-base leading-tight">
                {data.externalLabel}
              </div>
            </div>
            <span className="col-span-1 text-right font-narrow text-lg md:text-xl group-hover:translate-x-1 transition-transform">
              ↗
            </span>
          </a>
        </div>
      </div>

      {/* Episodes */}
      <div className="border-t border-ink px-6 md:px-10 py-8 md:py-12 bg-paper">
        <div className="label mb-6">três episódios · símbolos de resistência</div>
        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {data.episodes.map((ep) => (
            <div
              key={ep.n}
              className="col-span-12 md:col-span-4 border-l-2 border-brick pl-5"
            >
              <div className="font-display text-4xl md:text-5xl text-brick leading-none mb-3">
                {ep.n}
              </div>
              <div className="font-display uppercase text-xl md:text-2xl mb-2 leading-tight">
                {ep.who}
              </div>
              <p className="font-body text-sm md:text-base leading-relaxed text-[color:var(--ink)]/80">
                {ep.what}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Cobertura + repercussão — compact list (thumbs + links) */}
      <div
        className="border-t border-ink bg-off px-6 md:px-10 py-8 md:py-10"
        data-testid="sangue-azul-press"
      >
        <div className="flex items-baseline justify-between mb-4 md:mb-6">
          <div className="label">imprensa · repercussão</div>
          <span className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            {data.press.length} registros
          </span>
        </div>

        <ul className="border-t border-[color:var(--ink)]">
          {data.press.map((item, i) => {
            const isReel = item.kind === "reel";
            return (
              <li key={item.href} className="border-b border-[color:var(--ink)]">
                <a
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`sangue-azul-press-${i + 1}`}
                  className="group grid grid-cols-12 gap-3 md:gap-6 items-center py-3 md:py-4 hover:bg-brick hover:text-off transition-colors"
                >
                  <span className="col-span-3 md:col-span-2 relative overflow-hidden border border-[color:var(--ink)]/30 aspect-[4/3] bg-white">
                    <img
                      src={item.image}
                      alt={item.title}
                      loading="lazy"
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                  </span>
                  <span className="col-span-2 md:col-span-2 font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick group-hover:text-off/85 transition-colors leading-tight">
                    ✷ {item.outlet}
                    {isReel ? " · reel" : ""}
                  </span>
                  <span className="col-span-7 md:col-span-6 font-display uppercase text-sm md:text-base leading-tight">
                    {item.title}
                  </span>
                  <span className="hidden md:block md:col-span-1 font-narrow text-[10px] uppercase tracking-widest text-[color:var(--ink)]/50 group-hover:text-off/70">
                    {item.date}
                  </span>
                  <span className="col-span-12 md:col-span-1 text-right font-narrow text-lg md:text-xl group-hover:translate-x-1 transition-transform">
                    ↗
                  </span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </motion.article>
  );
}


/* ─── BUZZFEED VOZES · wrapper ─── */
function BuzzFeedVozesWrapper({ voz, sangue }) {
  return (
    <motion.section
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="relative"
      data-testid="buzzfeed-vozes-wrapper"
    >
      {/* Big logo header */}
      <div
        className="border border-[color:var(--ink)] bg-[#12E7C1] px-6 md:px-12 py-10 md:py-14 mb-10 md:mb-14 relative overflow-hidden"
        data-testid="buzzfeed-vozes-header"
      >
        <div className="grid grid-cols-12 gap-8 items-center">
          <div className="col-span-12 md:col-span-7">
            <div className="label mb-4 !text-ink">selo · buzzfeed brasil</div>
            {/* Typographic logo — inspired by original BuzzFeed Vozes lockup */}
            <div className="font-display uppercase leading-[0.85] tracking-[-0.02em] text-ink relative">
              <div className="text-sm md:text-lg font-narrow tracking-[0.2em] mb-1">
                BuzzFeed
              </div>
              <div className="relative">
                <div
                  aria-hidden="true"
                  className="absolute inset-0 text-[22vw] md:text-[13vw] leading-[0.82] tracking-[-0.04em] italic text-ink/25 select-none pointer-events-none"
                  style={{ transform: "translate(4px, 4px) skewX(-3deg)" }}
                >
                  VOZES
                </div>
                <div
                  className="relative text-[22vw] md:text-[13vw] leading-[0.82] tracking-[-0.04em] italic"
                  style={{ transform: "skewX(-3deg)" }}
                >
                  VOZES
                </div>
              </div>
            </div>
          </div>
          <div className="col-span-12 md:col-span-5 md:pl-6 md:border-l md:border-ink/30">
            <p className="font-display uppercase text-lg md:text-2xl leading-[1.1] mb-4 text-ink">
              CONTEÚDO PRODUZIDO POR — E COM — PROFISSIONAIS NÃO-BRANCOS.
            </p>
            <p className="font-body text-sm md:text-base leading-relaxed text-ink/85">
              O selo de diversidade do BuzzFeed Brasil, criado em 2019. Dois cases nos quais trabalhei desde a produção até a distribuição em redes: <em>A Voz Delas</em> e <em>Sangue Azul</em>.
            </p>
          </div>
        </div>
      </div>

      {/* Sub-cases stacked */}
      <div className="space-y-16 md:space-y-24">
        <VozDelasCase data={voz} />
        <SangueAzulCase data={sangue} />
      </div>
    </motion.section>
  );
}

/* ─── BUZZFEED ─── */
function BuzzFeedCase({ data }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="border border-[color:var(--ink)] bg-off"
      data-testid="project-buzzfeed"
    >
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-6 md:px-10 py-4 border-b border-[color:var(--ink)] bg-ink text-off">
        <div className="flex items-center gap-4">
          <span className="label !text-off">case · editorial</span>
          <span className="label !text-off/80">☺ redação + apresentação</span>
        </div>
        <span className="font-narrow text-sm">
          {data.agency} · {data.year}
        </span>
      </div>

      {/* Big title */}
      <div className="border-b border-ink px-6 md:px-10 py-10 md:py-14 bg-paper">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 md:col-span-6">
            <div className="label mb-4">gabriela ferraz · redação e vídeo</div>
            <h3 className="font-display uppercase text-[11vw] md:text-[5.2vw] leading-[0.88] tracking-[-0.01em]">
              <span className="text-brick">BUZZFEED</span>
              <br />
              EDITORIAL.
            </h3>
          </div>
          <div className="col-span-12 md:col-span-6">
            <p className="font-display uppercase text-lg md:text-xl leading-[1.15] mb-4">
              {data.tagline}
            </p>
            <p className="font-body text-sm md:text-base leading-relaxed text-[color:var(--ink)]/80">
              {data.concept}
            </p>
          </div>
        </div>
      </div>

      {/* Role */}
      <div className="border-b border-ink px-6 md:px-10 py-6 md:py-8 bg-off flex flex-col md:flex-row md:items-baseline gap-2 md:gap-8">
        <div className="label shrink-0">meu papel</div>
        <div className="font-display uppercase text-lg md:text-xl">
          {data.role}
        </div>
      </div>

      {/* TEXTOS — lista compacta */}
      <div className="border-b border-ink px-6 md:px-10 py-10 md:py-14 bg-paper">
        <div className="flex items-baseline justify-between mb-6 md:mb-8">
          <div>
            <div className="label mb-2">01 · textos</div>
            <div className="font-display uppercase text-3xl md:text-5xl leading-none">
              o que <span className="text-brick">escrevi.</span>
            </div>
          </div>
          <div className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            via web archive
          </div>
        </div>

        <ul
          className="border-t border-[color:var(--ink)]"
          data-testid="buzzfeed-articles"
        >
          {data.articles.map((a, i) => (
            <li key={a.href} className="border-b border-[color:var(--ink)]">
              <a
                href={a.href}
                target="_blank"
                rel="noreferrer"
                data-testid={`buzzfeed-article-${i + 1}`}
                className="group grid grid-cols-12 gap-4 md:gap-6 items-center py-4 md:py-5 hover:bg-brick hover:text-off transition-colors"
              >
                <span className="col-span-2 md:col-span-1 font-narrow text-xs text-brick group-hover:text-off transition-colors">
                  0{i + 1}
                </span>
                <span className="hidden md:block md:col-span-3 font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60 group-hover:text-off/85 transition-colors">
                  ✷ {a.kicker}
                </span>
                <span className="col-span-8 md:col-span-7 font-display uppercase text-base md:text-xl leading-tight">
                  {a.title}
                </span>
                <span className="col-span-2 md:col-span-1 text-right font-narrow text-lg md:text-xl group-hover:translate-x-1 transition-transform">
                  ↗
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* VÍDEOS */}
      <div className="px-6 md:px-10 py-10 md:py-14 bg-off">
        <div className="flex items-baseline justify-between mb-6 md:mb-10">
          <div>
            <div className="label mb-2">02 · vídeos</div>
            <div className="font-display uppercase text-3xl md:text-5xl leading-none">
              do que <span className="text-brick">participei.</span>
            </div>
          </div>
          <div className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            {data.videos.length} vídeos
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6" data-testid="buzzfeed-videos">
          {data.videos.map((v, i) => (
            <a
              key={v.id}
              href={`https://www.youtube.com/watch?v=${v.id}`}
              target="_blank"
              rel="noreferrer"
              data-testid={`buzzfeed-video-${i + 1}`}
              className="col-span-12 md:col-span-6 lg:col-span-4 group block"
            >
              <div className="border border-[color:var(--ink)] overflow-hidden relative bg-ink">
                <div className="aspect-video relative">
                  <img
                    src={`https://img.youtube.com/vi/${v.id}/hqdefault.jpg`}
                    alt={v.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                  <div className="absolute inset-0 bg-ink/20 group-hover:bg-ink/0 transition-colors" />
                  {/* Play badge */}
                  <div className="absolute bottom-3 left-3 flex items-center gap-2">
                    <span className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-brick flex items-center justify-center border border-off/20 group-hover:scale-110 transition-transform">
                      <span className="text-off text-lg md:text-xl leading-none translate-x-[1px]">
                        ▶
                      </span>
                    </span>
                    <span className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off bg-ink/70 px-2 py-1">
                      youtube ↗
                    </span>
                  </div>
                  <div className="absolute top-3 right-3 font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off bg-ink/70 px-2 py-1">
                    0{i + 1}
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <div className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick mb-1">
                  {v.series}
                </div>
                <div className="font-display uppercase text-lg md:text-xl leading-tight">
                  {v.title}
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Footer link */}
        <div className="mt-10 pt-6 border-t border-[color:var(--ink)]/20 font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
          ✷ buzzfeed brasil · textos e vídeos editoriais
        </div>
      </div>
    </motion.article>
  );
}

/* ─── TWEET CARD (Twitter/X native style) ─── */
function TweetCard({
  tweet,
  handle,
  displayName,
  verified = true,
  spans = "col-span-12 md:col-span-4",
  testId,
  featured = false,
}) {
  const isText = tweet.kind === "text";
  const isThread = tweet.kind === "thread";
  const initial = displayName?.[0]?.toUpperCase() || "@";
  const twStyle = {
    fontFamily:
      '"TwitterChirp","Segoe UI",Roboto,-apple-system,BlinkMacSystemFont,Arial,sans-serif',
  };

  return (
    <a
      href={tweet.href}
      target="_blank"
      rel="noreferrer"
      data-testid={testId}
      style={twStyle}
      className={`${spans} block bg-white text-[#0f1419] border border-[#eff3f4] rounded-2xl overflow-hidden hover:bg-[#f7f9f9] transition-colors`}
    >
      {/* Header */}
      <div className="flex items-start gap-3 px-4 pt-4">
        <div className="w-11 h-11 rounded-full bg-gradient-to-br from-brick to-ink flex items-center justify-center text-white font-bold text-lg shrink-0">
          {initial}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1 flex-wrap">
            <span className="font-bold text-[15px] leading-tight text-[#0f1419] truncate">
              {displayName}
            </span>
            {verified && (
              <svg
                aria-label="Conta verificada"
                className="w-[18px] h-[18px] shrink-0"
                viewBox="0 0 24 24"
                fill="#1d9bf0"
              >
                <path d="M22.25 12c0-1.43-.88-2.67-2.19-3.34.46-1.39.2-2.9-.81-3.91s-2.52-1.27-3.91-.81c-.66-1.31-1.91-2.19-3.34-2.19s-2.67.88-3.33 2.19c-1.4-.46-2.91-.2-3.92.81s-1.26 2.52-.8 3.91c-1.31.67-2.2 1.91-2.2 3.34s.89 2.67 2.2 3.34c-.46 1.39-.21 2.9.8 3.91s2.52 1.26 3.91.81c.67 1.31 1.91 2.19 3.34 2.19s2.68-.88 3.34-2.19c1.39.45 2.9.2 3.91-.81s1.27-2.52.81-3.91c1.31-.67 2.19-1.91 2.19-3.34zm-11.71 4.2L6.8 12.46l1.41-1.42 2.26 2.26 4.8-5.23 1.47 1.36-6.2 6.77z" />
              </svg>
            )}
          </div>
          <div className="text-[15px] text-[#536471] leading-tight mt-0.5 truncate">
            {handle}
          </div>
        </div>
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className="w-6 h-6 shrink-0 text-[#0f1419]"
          fill="currentColor"
        >
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      </div>

      {/* Body */}
      <div className="px-4 pt-3">
        <p
          className={`whitespace-pre-wrap ${
            isThread || featured
              ? "text-[22px] md:text-[24px] leading-[1.3]"
              : "text-[17px] leading-[1.3]"
          } text-[#0f1419]`}
        >
          {tweet.emojis && <span className="mr-1">{tweet.emojis}</span>}
          {tweet.text}
          {tweet.tags && (
            <>
              {" "}
              {tweet.tags
                .split(/\s+/)
                .filter(Boolean)
                .map((t, i) => (
                  <span key={i} className="text-[#1d9bf0]">
                    {t}
                    {i < tweet.tags.split(/\s+/).filter(Boolean).length - 1 &&
                      " "}
                  </span>
                ))}
            </>
          )}
        </p>
      </div>

      {/* Media */}
      {tweet.image && (
        <div className="relative bg-black overflow-hidden mt-3 mx-4 rounded-2xl border border-[#cfd9de]">
          <img
            src={tweet.image}
            alt=""
            loading="lazy"
            className="w-full h-auto block"
          />
          {tweet.video && (
            <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <span className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-black/70 flex items-center justify-center">
                <svg
                  viewBox="0 0 24 24"
                  className="w-6 h-6 md:w-7 md:h-7 text-white translate-x-[1px]"
                  fill="currentColor"
                >
                  <path d="M8 5v14l11-7z" />
                </svg>
              </span>
            </span>
          )}
        </div>
      )}

      {/* Date */}
      <div className="px-4 pt-3 text-[15px] text-[#536471]">{tweet.date}</div>

      {/* Actions bar */}
      <div className="px-4 py-3 flex items-center gap-6 text-[13px] text-[#536471] border-t border-[#eff3f4] mt-3">
        <span className="flex items-center gap-1.5">
          <svg
            viewBox="0 0 24 24"
            className="w-[18px] h-[18px]"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M1.751 10c0-4.42 3.584-8 8.005-8h4.366c4.49 0 8.129 3.64 8.129 8.13 0 2.96-1.607 5.68-4.196 7.11l-8.054 4.46v-3.69h-.067c-4.49.1-8.183-3.51-8.183-8.01z" />
          </svg>
          {tweet.replies || 0}
        </span>
        <span className="flex items-center gap-1.5">
          <svg
            viewBox="0 0 24 24"
            className="w-[18px] h-[18px]"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M4.5 3.88l4.432 4.14-1.364 1.46L5.5 7.55V16c0 1.1.896 2 2 2H13v2H7.5c-2.209 0-4-1.79-4-4V7.55L1.432 9.48.068 8.02 4.5 3.88zM16.5 6H11V4h5.5c2.209 0 4 1.79 4 4v8.45l2.068-1.93 1.364 1.46-4.432 4.14-4.432-4.14 1.364-1.46 2.068 1.93V8c0-1.1-.896-2-2-2z" />
          </svg>
          —
        </span>
        <span className="flex items-center gap-1.5">
          <svg
            viewBox="0 0 24 24"
            className="w-[18px] h-[18px]"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M16.697 5.5c-1.222-.06-2.679.51-3.89 2.16l-.805 1.09-.806-1.09C9.984 6.01 8.526 5.44 7.304 5.5c-1.243.07-2.349.78-2.91 1.91-.552 1.12-.633 2.78.479 4.82 1.074 1.97 3.257 4.27 7.129 6.61 3.87-2.34 6.052-4.64 7.126-6.61 1.111-2.04 1.03-3.7.477-4.82-.561-1.13-1.666-1.84-2.908-1.91z" />
          </svg>
          {tweet.likes.toLocaleString("pt-BR")}
        </span>
        <span className="ml-auto flex items-center gap-1.5 text-[13px] text-[#1d9bf0]">
          ler no x ↗
        </span>
      </div>
    </a>
  );
}

/* ─── BRING ME EM PORTUGUÊS ─── */
function BringMeCase({ data }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="border border-[color:var(--ink)] bg-paper"
      data-testid="project-bring-me"
    >
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-6 md:px-10 py-4 border-b border-[color:var(--ink)] bg-paper">
        <div className="flex items-center gap-4">
          <span className="label">case · viagem</span>
          <span className="label text-brick">☺ editorial + guia</span>
        </div>
        <span className="font-narrow text-sm">
          {data.agency} · {data.year}
        </span>
      </div>

      {/* Compact hero — logo + title */}
      <div className="border-b border-ink px-6 md:px-10 py-6 md:py-8 bg-off">
        <div className="grid grid-cols-12 gap-6 md:gap-8 items-center">
          <div className="col-span-4 md:col-span-2">
            <div className="border border-[color:var(--ink)] bg-white p-3 md:p-4 aspect-square flex items-center justify-center">
              <img
                src="/bringme-logo.png"
                alt="Bring Me!"
                className="w-full h-auto block"
                loading="lazy"
                data-testid="bring-me-logo"
              />
            </div>
          </div>
          <div className="col-span-8 md:col-span-10">
            <div className="label mb-2">buzzfeed brasil · vertical de viagem</div>
            <h3 className="font-display uppercase text-[8vw] md:text-[3.8vw] leading-[0.9]">
              <span className="text-brick">BRING</span> ME EM PORTUGUÊS.
            </h3>
            <p className="mt-3 font-display uppercase text-sm md:text-base leading-[1.2] max-w-[720px]">
              {data.tagline}
            </p>
          </div>
        </div>
        <div className="mt-6 pt-5 border-t border-[color:var(--ink)]/20 grid grid-cols-12 gap-4 md:gap-8 text-[color:var(--ink)]/85">
          <p className="col-span-12 md:col-span-8 font-body text-sm md:text-base leading-relaxed">
            {data.concept}
          </p>
          <div className="col-span-12 md:col-span-4">
            <div className="label mb-1">meu papel</div>
            <div className="font-display uppercase text-sm md:text-base leading-tight">
              {data.role}
            </div>
          </div>
        </div>
      </div>

      {/* TEXTOS — lista compacta */}
      <div className="border-b border-ink px-6 md:px-10 py-6 md:py-8 bg-off">
        <div className="flex items-baseline justify-between mb-4 md:mb-5">
          <div>
            <div className="label mb-1">01 · listas + guias</div>
            <div className="font-display uppercase text-xl md:text-2xl leading-none">
              para <span className="text-brick">levar o brasil</span> no bolso.
            </div>
          </div>
          <div className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            via web archive
          </div>
        </div>

        <ul
          className="border-t border-[color:var(--ink)]"
          data-testid="bring-me-articles"
        >
          {data.articles.map((a, i) => (
            <li key={a.href} className="border-b border-[color:var(--ink)]">
              <a
                href={a.href}
                target="_blank"
                rel="noreferrer"
                data-testid={`bring-me-article-${i + 1}`}
                className="group grid grid-cols-12 gap-3 md:gap-5 items-center py-3 hover:bg-brick hover:text-off transition-colors"
              >
                <span className="col-span-2 md:col-span-1 font-narrow text-xs text-brick group-hover:text-off transition-colors">
                  0{i + 1}
                </span>
                <span className="hidden md:block md:col-span-3 font-narrow text-[10px] uppercase tracking-widest text-[color:var(--ink)]/60 group-hover:text-off/85 transition-colors">
                  ✷ {a.kicker}
                </span>
                <span className="col-span-8 md:col-span-7 font-display uppercase text-sm md:text-base leading-tight">
                  {a.title}
                </span>
                <span className="col-span-2 md:col-span-1 text-right font-narrow text-base group-hover:translate-x-1 transition-transform">
                  ↗
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* VIDEO + TWEET */}
      <div className="border-b border-ink px-6 md:px-10 py-6 md:py-8 bg-paper">
        <div className="mb-4 md:mb-5">
          <div className="label mb-1">02 · vídeos</div>
          <div className="font-display uppercase text-xl md:text-2xl leading-none">
            para <span className="text-brick">assistir.</span>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {/* YouTube video card */}
          <a
            href={`https://www.youtube.com/watch?v=${data.video.id}`}
            target="_blank"
            rel="noreferrer"
            data-testid="bring-me-video"
            className="col-span-12 md:col-span-7 group block"
          >
            <div className="border border-[color:var(--ink)] overflow-hidden relative bg-ink">
              <div className="aspect-video relative">
                <img
                  src={`https://img.youtube.com/vi/${data.video.id}/hqdefault.jpg`}
                  alt={data.video.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
                <div className="absolute inset-0 bg-ink/25 group-hover:bg-ink/0 transition-colors" />
                <div className="absolute bottom-3 left-3 flex items-center gap-2">
                  <span className="w-11 h-11 md:w-14 md:h-14 rounded-full bg-brick flex items-center justify-center border border-off/20 group-hover:scale-110 transition-transform">
                    <span className="text-off text-lg md:text-2xl leading-none translate-x-[1px]">
                      ▶
                    </span>
                  </span>
                  <span className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off bg-ink/70 px-2 py-1">
                    youtube ↗
                  </span>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <div className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick mb-1">
                {data.video.series}
              </div>
              <div className="font-display uppercase text-xl md:text-3xl leading-tight">
                {data.video.title}
              </div>
            </div>
          </a>

          {/* Twitter video card — pão assado */}
          <div
            className="col-span-12 md:col-span-5 bg-ink text-off p-4 md:p-6 flex flex-col"
            data-testid="bring-me-reel"
          >
            <div className="flex items-center justify-between mb-4 font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off/70">
              <span className="flex items-center gap-2">
                <span className="text-brick">◉</span>
                <span>tweet · vídeo</span>
              </span>
              <span>{data.reel.date}</span>
            </div>

            <a
              href={data.reel.href}
              target="_blank"
              rel="noreferrer"
              data-testid="bring-me-reel-link"
              className="group block"
            >
              <div className="border border-off/20 overflow-hidden shadow-[5px_5px_0_0_var(--ink)] bg-black">
                <div className="flex items-center gap-2 px-3 py-2 border-b border-off/20 bg-ink">
                  <span className="w-2.5 h-2.5 rounded-full bg-brick/70" />
                  <span className="w-2.5 h-2.5 rounded-full bg-off/30" />
                  <span className="w-2.5 h-2.5 rounded-full bg-off/30" />
                  <span className="ml-3 font-narrow text-[10px] md:text-xs text-off/60 truncate">
                    {data.reel.domain}
                  </span>
                </div>
                <div className="relative bg-black flex justify-center">
                  <img
                    src={data.reel.image}
                    alt="Bring Me em Português — pão assado"
                    loading="lazy"
                    className="w-full h-auto block transition-transform duration-700 group-hover:scale-[1.02]"
                  />
                  <span className="absolute inset-0 flex items-center justify-center">
                    <span className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-brick flex items-center justify-center border border-off/20 group-hover:scale-110 transition-transform">
                      <span className="text-off text-xl md:text-2xl leading-none translate-x-[1px]">
                        ▶
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            </a>

            <div className="mt-5 flex flex-col gap-3">
              <div className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick">
                {data.reel.outlet}
              </div>
              <div className="font-display uppercase text-base md:text-xl leading-[1.1]">
                "{data.reel.text}"
              </div>
              <div className="font-narrow text-xs uppercase tracking-widest text-off/50">
                {data.reel.tags}
              </div>
              <div className="font-narrow text-xs uppercase tracking-widest text-off/60">
                ✷ {data.reel.likes} curtidas · {data.reel.replies} resposta
              </div>
              <a
                href={data.reel.href}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 mt-1 font-narrow text-xs uppercase tracking-widest border-b border-off/40 pb-0.5 self-start text-off hover:text-brick hover:border-brick transition-colors"
              >
                <span>assistir no twitter</span>
                <span>↗</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* SOCIAL — Twitter cards editorial grid */}
      <div
        className="border-t border-ink px-6 md:px-10 py-6 md:py-8 bg-off"
        data-testid="bring-me-social"
      >
        <div className="flex items-baseline justify-between mb-4 md:mb-5">
          <div>
            <div className="label mb-1">03 · twitter</div>
            <div className="font-display uppercase text-xl md:text-2xl leading-none">
              conteúdo que <span className="text-brick">criei.</span>
            </div>
          </div>
          <div className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            @bringmept · {data.tweets.length} tweets
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-5" data-testid="bring-me-tweets">
          {data.tweets.map((t, i) => {
            const isThread = t.kind === "thread";
            const isText = t.kind === "text";
            const spans = isThread
              ? "col-span-12 md:col-span-7"
              : isText
              ? "col-span-12 md:col-span-5"
              : i === 1
              ? "col-span-12 md:col-span-5"
              : "col-span-12 md:col-span-4";
            return (
              <TweetCard
                key={t.id}
                tweet={t}
                handle="@bringmept"
                displayName="Bring Me em Português"
                verified
                spans={spans}
                testId={`bring-me-tweet-${i + 1}`}
                featured={isThread}
              />
            );
          })}
        </div>
      </div>
    </motion.article>
  );
}


/* ─── ENGOV AFTER · #EngovAfterNoBBB ─── */
function EngovCase({ data }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="border border-[color:var(--ink)] bg-off"
      data-testid="project-engov"
    >
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-6 md:px-10 py-4 border-b border-[color:var(--ink)] bg-ink text-off">
        <div className="flex items-center gap-4">
          <span className="label !text-off">case · social</span>
          <span className="label !text-off/80">☺ estratégia + redação</span>
        </div>
        <span className="font-narrow text-sm">
          {data.agency} · {data.year}
        </span>
      </div>

      {/* Hero — image + title */}
      <div className="grid grid-cols-12 gap-0 border-b border-ink">
        <div className="col-span-12 md:col-span-6 md:border-r md:border-ink relative overflow-hidden bg-[#F3D023] flex items-center justify-center">
          <img
            src={data.hero}
            alt="Engov After — Bonde da Curtição — próxima parada #EngovNoBBB"
            className="w-full h-auto block"
            loading="lazy"
            data-testid="engov-hero-image"
          />
        </div>
        <div className="col-span-12 md:col-span-6 p-8 md:p-12 flex flex-col justify-between gap-8">
          <div>
            <div className="label mb-4">{data.client} · {data.year}</div>
            <h3 className="font-display uppercase text-[10vw] md:text-[5.5vw] leading-[0.88]">
              ENGOV
              <br />
              <span className="text-brick">AFTER.</span>
            </h3>
            <p className="mt-6 font-display uppercase text-lg md:text-2xl leading-[1.1] max-w-[520px]">
              {data.tagline}
            </p>
            <div className="mt-6 inline-flex items-center gap-3 border border-brick bg-brick text-off px-4 py-2 font-narrow text-xs md:text-sm uppercase tracking-widest">
              <span>{data.hashtag}</span>
              <span className="text-off/60">·</span>
              <span>{data.handle}</span>
            </div>
          </div>
          <div>
            <div className="label mb-2">meu papel</div>
            <div className="font-display uppercase text-base md:text-lg">
              {data.role}
            </div>
          </div>
        </div>
      </div>

      {/* Chapters — narrative timeline */}
      <div data-testid="engov-chapters">
        {data.chapters.map((ch, i) => {
          const bg = i % 2 === 0 ? "bg-off" : "bg-paper";
          return (
            <div
              key={ch.n}
              className={`border-t border-ink ${bg}`}
              data-testid={`engov-chapter-${ch.n}`}
            >
              <div className="px-6 md:px-10 py-8 md:py-12 grid grid-cols-12 gap-6 md:gap-10">
                <div className="col-span-12 md:col-span-3 flex md:flex-col items-baseline md:items-start gap-3 md:gap-4">
                  <div className="font-display text-4xl md:text-6xl text-brick leading-none">
                    {ch.n}
                  </div>
                  <div className="label">{ch.k}</div>
                </div>
                <div className="col-span-12 md:col-span-9">
                  <h4 className="font-display uppercase text-xl md:text-3xl leading-[1.05] mb-4">
                    {ch.title}
                  </h4>
                  <p className="font-body text-sm md:text-base leading-relaxed max-w-[720px] text-[color:var(--ink)]/85">
                    {ch.body}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Tweets */}
      <div className="border-t border-ink px-6 md:px-10 py-10 md:py-14 bg-off" data-testid="engov-tweets-section">
        <div className="flex items-baseline justify-between mb-6 md:mb-10">
          <div>
            <div className="label mb-2">a entrega · twitter</div>
            <div className="font-display uppercase text-2xl md:text-4xl leading-none">
              a marca que virou <span className="text-brick">creator.</span>
            </div>
          </div>
          <div className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            {data.handle} · {data.tweets.length} tweets
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-5" data-testid="engov-tweets">
          {data.tweets.map((t, i) => {
            const isFeatured = t.featured;
            const isText = t.kind === "text";
            const spans = isFeatured
              ? "col-span-12 md:col-span-7"
              : isText
              ? "col-span-12 md:col-span-5"
              : i === 1
              ? "col-span-12 md:col-span-5"
              : "col-span-12 md:col-span-4";
            return (
              <TweetCard
                key={t.id}
                tweet={t}
                handle="@Engov_Oficial"
                displayName="Engov"
                verified
                spans={spans}
                testId={`engov-tweet-${i + 1}`}
                featured={isFeatured}
              />
            );
          })}
        </div>
      </div>

      {/* Instagram TV */}
      <div
        className="border-t border-ink px-6 md:px-10 py-10 md:py-14 bg-paper"
        data-testid="engov-igtv"
      >
        <div className="mb-6 md:mb-10">
          <div className="label mb-2">a entrega · instagram</div>
          <div className="font-display uppercase text-2xl md:text-4xl leading-none">
            também no <span className="text-brick">feed.</span>
          </div>
        </div>

        <a
          href={data.igtv.href}
          target="_blank"
          rel="noreferrer"
          data-testid="engov-igtv-link"
          className="group grid grid-cols-12 gap-0 border border-[color:var(--ink)] bg-ink text-off overflow-hidden hover:border-brick transition-colors"
        >
          <div className="col-span-12 md:col-span-4 relative bg-black flex items-center justify-center overflow-hidden">
            <img
              src={data.igtv.image}
              alt={data.igtv.text}
              loading="lazy"
              className="w-full h-full object-cover block max-h-[480px] transition-transform duration-700 group-hover:scale-[1.02]"
            />
            <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
              <span className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-brick flex items-center justify-center border border-off/20">
                <span className="text-off text-xl md:text-2xl leading-none translate-x-[1px]">
                  ▶
                </span>
              </span>
            </span>
          </div>
          <div className="col-span-12 md:col-span-8 p-6 md:p-10 flex flex-col justify-between gap-6">
            <div>
              <div className="flex items-center gap-3 mb-4 font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off/70">
                <span className="text-brick">◉ instagram · igtv</span>
                <span className="text-off/50">{data.igtv.handle}</span>
                <span className="text-off/50">·</span>
                <span>{data.igtv.date}</span>
              </div>
              <div className="text-3xl md:text-4xl mb-3">{data.igtv.emojis}</div>
              <div className="font-display uppercase text-xl md:text-3xl leading-[1.05] mb-4">
                "{data.igtv.text}"
              </div>
              <div className="font-narrow text-xs uppercase tracking-widest text-brick">
                {data.igtv.tags}
              </div>
            </div>
            <div className="flex items-center justify-between border-t border-off/20 pt-4">
              <div className="font-narrow text-xs uppercase tracking-widest text-off/60">
                ♡ {data.igtv.likes} curtidas · 💬 {data.igtv.comments} comentários
              </div>
              <div className="font-narrow text-xs uppercase tracking-widest text-off group-hover:text-brick transition-colors">
                assistir no instagram ↗
              </div>
            </div>
          </div>
        </a>
      </div>

      {/* Repercussão — compact list (thumbs + links) */}
      <div
        className="border-t border-ink px-6 md:px-10 py-10 md:py-14 bg-off"
        data-testid="engov-press"
      >
        <div className="flex items-baseline justify-between mb-6 md:mb-8">
          <div>
            <div className="label mb-2">repercussão · na mídia</div>
            <div className="font-display uppercase text-2xl md:text-4xl leading-none">
              a <span className="text-brick">imprensa</span> falou.
            </div>
          </div>
          <div className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            {data.press.length} matérias
          </div>
        </div>

        <ul className="border-t border-[color:var(--ink)]">
          {data.press.map((p, i) => (
            <li key={p.href} className="border-b border-[color:var(--ink)]">
              <a
                href={p.href}
                target="_blank"
                rel="noreferrer"
                data-testid={`engov-press-${i + 1}`}
                className="group grid grid-cols-12 gap-3 md:gap-6 items-center py-3 md:py-4 hover:bg-brick hover:text-off transition-colors"
              >
                <span className="col-span-3 md:col-span-2 relative overflow-hidden border border-[color:var(--ink)]/30 aspect-[4/3] bg-white">
                  <img
                    src={p.image}
                    alt={p.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                </span>
                <span className="col-span-2 md:col-span-2 font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick group-hover:text-off/85 transition-colors leading-tight">
                  ✷ {p.outlet}
                </span>
                <span className="col-span-7 md:col-span-6 font-display uppercase text-sm md:text-lg leading-tight">
                  {p.title}
                </span>
                <span className="hidden md:block md:col-span-1 font-narrow text-[10px] uppercase tracking-widest text-[color:var(--ink)]/50 group-hover:text-off/70">
                  {p.date}
                </span>
                <span className="col-span-12 md:col-span-1 text-right font-narrow text-lg md:text-xl group-hover:translate-x-1 transition-transform">
                  ↗
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Metrics */}
      <div className="border-t border-ink bg-brick text-off px-6 md:px-10 py-8 md:py-10">
        <div className="label !text-off/85 mb-6">resultados · em números</div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {data.metrics.map((m, j) => (
            <div key={j}>
              <div className="font-display text-3xl md:text-5xl leading-none">
                {m.k}
              </div>
              <div className="mt-2 font-narrow text-xs md:text-sm text-off/85 leading-tight">
                {m.d}
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.article>
  );
}


/* ─── TASTY DEMAIS ─── */
function TastyCase({ data }) {
  return (
    <motion.article
      layout
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      transition={{ duration: 0.7, ease: [0.7, 0, 0.2, 1] }}
      className="border border-[color:var(--ink)] bg-paper"
      data-testid="project-tasty"
    >
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-3 px-6 md:px-10 py-4 border-b border-[color:var(--ink)] bg-paper">
        <div className="flex items-center gap-4">
          <span className="label">case · social</span>
          <span className="label text-brick">☺ gestão + estratégia</span>
        </div>
        <span className="font-narrow text-sm">
          {data.agency} · {data.year}
        </span>
      </div>

      {/* Compact hero — logo + title */}
      <div className="border-b border-ink px-6 md:px-10 py-6 md:py-8 bg-off">
        <div className="grid grid-cols-12 gap-6 md:gap-8 items-center">
          <div className="col-span-4 md:col-span-2">
            <div className="border border-[color:var(--ink)] bg-white p-2 md:p-3 aspect-square flex items-center justify-center overflow-hidden">
              <img
                src="/tasty-logo.png"
                alt="Tasty Demais"
                className="w-full h-full object-cover block"
                loading="lazy"
                data-testid="tasty-logo"
              />
            </div>
          </div>
          <div className="col-span-8 md:col-span-10">
            <div className="label mb-2">buzzfeed brasil · comida + timeline</div>
            <h3 className="font-display uppercase text-[9vw] md:text-[4vw] leading-[0.9]">
              <span className="text-brick">TASTY</span> DEMAIS.
            </h3>
            <p className="mt-3 font-display uppercase text-sm md:text-base leading-[1.2] max-w-[720px]">
              {data.tagline}
            </p>
          </div>
        </div>
        <div className="mt-6 pt-5 border-t border-[color:var(--ink)]/20 grid grid-cols-12 gap-4 md:gap-8 text-[color:var(--ink)]/85">
          <p className="col-span-12 md:col-span-8 font-body text-sm md:text-base leading-relaxed">
            {data.concept}
          </p>
          <div className="col-span-12 md:col-span-4">
            <div className="label mb-1">meu papel</div>
            <div className="font-display uppercase text-sm md:text-base leading-tight">
              {data.role}
            </div>
          </div>
        </div>
      </div>

      {/* Canais */}
      <div className="border-b border-ink px-6 md:px-10 py-5 md:py-6 bg-paper">
        <div className="grid grid-cols-12 gap-3 md:gap-6 items-center">
          <div className="col-span-12 md:col-span-3">
            <div className="label">canais que geria</div>
          </div>
          <ul className="col-span-12 md:col-span-9 grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4">
            {data.channels.map((c) => (
              <li key={c.name}>
                <a
                  href={c.href}
                  target="_blank"
                  rel="noreferrer"
                  className="group flex items-baseline justify-between border-b border-[color:var(--ink)]/30 pb-1.5 hover:border-brick transition-colors"
                >
                  <span className="font-display uppercase text-sm md:text-base">
                    {c.name}
                  </span>
                  <span className="font-narrow text-[10px] uppercase tracking-widest text-[color:var(--ink)]/60 group-hover:text-brick transition-colors">
                    ↗
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Tweets */}
      <div className="border-b border-ink px-6 md:px-10 py-6 md:py-8 bg-off" data-testid="tasty-tweets-section">
        <div className="flex items-baseline justify-between mb-4 md:mb-5">
          <div>
            <div className="label mb-1">01 · twitter</div>
            <div className="font-display uppercase text-xl md:text-2xl leading-none">
              conteúdo de <span className="text-brick">timeline.</span>
            </div>
          </div>
          <div className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            @tastydemais · {data.tweets.length} tweets
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-5" data-testid="tasty-tweets">
          {data.tweets.map((t, i) => {
            const isFeatured = t.featured;
            const isText = t.kind === "text";
            const spans = isFeatured
              ? "col-span-12 md:col-span-7"
              : isText
              ? "col-span-12 md:col-span-5"
              : "col-span-12 md:col-span-5";
            return (
              <div key={t.id} className={`${spans} flex flex-col gap-2`}>
                <TweetCard
                  tweet={t}
                  handle="@tastydemais"
                  displayName="Tasty Demais"
                  verified
                  spans=""
                  testId={`tasty-tweet-${i + 1}`}
                  featured={isFeatured}
                />
                {t.badge && (
                  <a
                    href={t.badgeHref}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-2 self-start font-narrow text-[10px] md:text-xs uppercase tracking-widest bg-brick text-off px-3 py-1.5 hover:bg-ink transition-colors"
                  >
                    <span>✷ {t.badge}</span>
                    <span>↗</span>
                  </a>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Videos — YouTube */}
      <div className="px-6 md:px-10 py-6 md:py-8 bg-paper">
        <div className="flex items-baseline justify-between mb-4 md:mb-5">
          <div>
            <div className="label mb-1">02 · vídeos</div>
            <div className="font-display uppercase text-xl md:text-2xl leading-none">
              e de <span className="text-brick">canal.</span>
            </div>
          </div>
          <div className="hidden md:block font-narrow text-xs uppercase tracking-widest text-[color:var(--ink)]/60">
            {data.videos.length} vídeos
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-5" data-testid="tasty-videos">
          {data.videos.map((v, i) => (
            <a
              key={v.title}
              href={v.href}
              target="_blank"
              rel="noreferrer"
              data-testid={`tasty-video-${i + 1}`}
              className={`col-span-12 md:col-span-6 group block border border-[color:var(--ink)] bg-off hover:border-brick transition-colors overflow-hidden`}
            >
              <div className="aspect-video relative bg-ink flex items-center justify-center overflow-hidden">
                {v.thumbnail ? (
                  <img
                    src={v.thumbnail}
                    alt={v.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                ) : (
                  <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-brick to-ink text-off">
                    <span className="font-display uppercase text-2xl md:text-4xl">
                      #TastyTesta
                    </span>
                    <span className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-off/80">
                      youtube · Tasty Demais
                    </span>
                  </div>
                )}
                <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <span className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-brick flex items-center justify-center border border-off/20 group-hover:scale-110 transition-transform">
                    <span className="text-off text-xl md:text-2xl leading-none translate-x-[1px]">
                      ▶
                    </span>
                  </span>
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="font-narrow text-[10px] md:text-xs uppercase tracking-widest text-brick mb-2">
                  {v.series}
                </div>
                <div className="font-display uppercase text-lg md:text-xl leading-tight">
                  {v.title}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Metrics */}
      <div className="border-t border-ink bg-brick text-off px-6 md:px-10 py-8 md:py-10">
        <div className="label !text-off/85 mb-6">resultados · em números</div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {data.metrics.map((m, j) => (
            <div key={j}>
              <div className="font-display text-3xl md:text-5xl leading-none">
                {m.k}
              </div>
              <div className="mt-2 font-narrow text-xs md:text-sm text-off/85 leading-tight">
                {m.d}
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.article>
  );
}

